module.exports = __webpack_public_path__ + "img/Vonex2colours.c19db50c.png";